import React from 'react';
import classNames from 'classnames';
import { isEmpty } from 'lodash';

// get previous button view
const getPrevButtonView = ( props ) => {
    const visibility = props.canMoveBackward ? 'visible' : 'hidden';

    // arrow class name
    const arrowClassName = classNames( 'ui-force-scroller__nav-button ui-force-scroller__nav-button--prev', props.arrowClassName, {
        [ `ui-force-scroller__nav-button--${ props.arrowStyle }` ]: ! isEmpty( props.arrowStyle ),
    } );

    if( props.prevButtonView ) {
        return <props.prevButtonView visibility={ visibility } onClick = { props.moveBackward } previousArrowClassName ={ props.previousArrowClassName }/>;
    } else {
        return <div className={ arrowClassName } style={ { visibility } } onClick = { props.moveBackward }/>;
    }
};

// get next button view
const getNextButtonView = ( props ) => {
    const visibility = props.canMoveForward ? 'visible' : 'hidden';

    // arrow class name
    const arrowClassName = classNames( 'ui-force-scroller__nav-button ui-force-scroller__nav-button--next', props.arrowClassName, {
        [ `ui-force-scroller__nav-button--${ props.arrowStyle }` ]: ! isEmpty( props.arrowStyle ),
    } );

    if( props.nextButtonView ) {
        return <props.nextButtonView visibility={ visibility } onClick={ props.moveForward } nextArrowClassName ={ props.nextArrowClassName }/>;
    } else {
        return <div className={ arrowClassName } style={ { visibility } } onClick={ props.moveForward }/>;
    }
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { forceScroller as ForceScroller } from 'modules/force-scroller';
 *
 * // render
 * <ForceScroller propName='propValue'/>
 */
export const forceScroller = React.forwardRef( ( props, forwardedRef ) => {
	const widgetClassName = classNames( 'ui-force-scroller', props.className );
	const visibility = props.isVisible ? 'visible' : 'hidden';
    const _wrapperContainerClassName = classNames( 'ui-force-scroller__wrapper__container', props.wrapperContainerClassName );
    
    const _wrapperContainerItemClassName = classNames( 'ui-force-scroller__wrapper__container__item', props.wrapperContainerItemClassName, {
        'ui-force-scroller__wrapper__container__item--expand': props.expandColumns,
    } );

    return (
        <div className={ widgetClassName } ref={ forwardedRef } style={ { visibility } }>
            {   // previous button
                getPrevButtonView( props, props.canMoveBackward )
            }

            <div className='ui-force-scroller__wrapper' >
                <props.tagName className = { _wrapperContainerClassName }style={ { transform: `translateX( -${ props.scrollAmount }px )`, transitionDuration: `${ props.canAnimate ? props.scrollAnimationDuration : 0 }ms` } }>
                    {   // wrap item with a wrapper item className
                        React.Children.map( props.children, ( itemView, index ) => {
							const isLastChild = index === props.children.length - 1;
                            return (
                                <props.itemTagName className={ _wrapperContainerItemClassName } style={ { marginRight: isLastChild ? 0 : props.gutter } }>
                                    { itemView }
                                </props.itemTagName>
                            );
                        } )
                    }
                </props.tagName>
            </div>

            {   // next button
                getNextButtonView( props )
            }
        </div>
    );
} );

// set display name
forceScroller.displayName = 'forceScroller';

// set default props
forceScroller.defaultProps = {
	tagName: 'ul',
    itemTagName: 'li',
    arrowStyle: 'default', // could be 'default', 'minimal'
};

// prop types
forceScroller.propTypes = {};
